import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Lock } from 'lucide-react';

import { ClientDashboardPreviewPlaceholder } from './ClientDashboardPreviewPlaceholder';

export function ClientDashboardWelcomeSection() {
  return (
    <>
      <div className="client-dash__step-cards">
        <article className="client-dash__step-card client-dash__step-card--active">
          <header className="client-dash__step-card-head">
            <span className="client-dash__step-card-badge client-dash__step-card-badge--active">
              1
            </span>
            <span className="client-dash__step-card-phase">Step 1 · In progress</span>
          </header>
          <h3 className="client-dash__step-card-title">Select capabilities</h3>
          <p className="client-dash__step-card-desc">
            Choose the capability areas this project should be measured on. The assessment
            questions are built from what you pick.
          </p>
          <div className="client-dash__step-card-actions">
            <Link
              to="/capabilities"
              className="app-btn app-btn--primary app-btn--sm client-dash__step-card-btn client-dash__step-card-btn--primary"
              data-element="capabilities"
            >
              Select capabilities
              <ArrowRight size={16} aria-hidden />
            </Link>
            <span className="client-dash__step-card-progress">0 selected</span>
          </div>
        </article>

        <article className="client-dash__step-card client-dash__step-card--locked">
          <header className="client-dash__step-card-head">
            <span className="client-dash__step-card-badge client-dash__step-card-badge--locked">
              2
            </span>
            <span className="client-dash__step-card-phase">Step 2 · Locked</span>
          </header>
          <h3 className="client-dash__step-card-title">Start the assessment</h3>
          <p className="client-dash__step-card-desc">
            Rate the current and target state for each selected capability. Unlocks once at least
            one capability is selected.
          </p>
          <button
            type="button"
            className="app-btn app-btn--outline app-btn--sm client-dash__step-card-btn client-dash__step-card-btn--locked"
            disabled
          >
            <Lock size={14} aria-hidden />
            Start assessment
          </button>
        </article>
      </div>

      <ClientDashboardPreviewPlaceholder />
    </>
  );
}

export default ClientDashboardWelcomeSection;
